// extracted by mini-css-extract-plugin
module.exports = {"root":"Register_root__1maX9","main":"Register_main__3-z_p","header":"Register_header__2K8Tt","mainPaper":"Register_mainPaper__1P-_q"};